import {
  table,
  SMART_BUYER_CALCULATOR_CONDITION_VALUE,
  SMART_BUYER_FIRST_CALCULATOR_DIVIDER,
  SMART_BUYER_SECOND_CALCULATOR_DIVIDER,
} from "./data";

export const calculateResult = (propertyValue: number, propertyType: number, buyingType: number) => {
  let rowIndex = Math.floor(propertyValue / SMART_BUYER_FIRST_CALCULATOR_DIVIDER) % table.length;
  if (propertyValue > SMART_BUYER_CALCULATOR_CONDITION_VALUE) {
    const conditionIndex = Math.floor((SMART_BUYER_CALCULATOR_CONDITION_VALUE + 0.1) / SMART_BUYER_FIRST_CALCULATOR_DIVIDER) % table.length;
    const calculatedIndex = Math.floor(propertyValue / SMART_BUYER_SECOND_CALCULATOR_DIVIDER);
    rowIndex = (conditionIndex + calculatedIndex) % table.length;
  }
  return table[rowIndex][propertyType][buyingType];
};
